import { NfcTapIcon } from './NfcTapIcon';

/**
 * author: Austin Andrews
 * id 656C274C-CDC8-4FB6-AFFA-F704784BC997
 * name nfc-tap
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/nfc-tap.svg
 * tags
 */
export const NearFieldCommunicationTapIcon = NfcTapIcon;
export default NearFieldCommunicationTapIcon